import { render, staticRenderFns } from "./SocialAccounts.vue?vue&type=template&id=d530eb42&scoped=true&"
import script from "./SocialAccounts.vue?vue&type=script&lang=js&"
export * from "./SocialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SocialAccounts.vue?vue&type=style&index=0&id=d530eb42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d530eb42",
  null
  
)

export default component.exports